/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-04-15 17:42:40
 * @FilePath: /bar-admin/src/api/login/index.ts
 */
import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<any>> => {
  // return request.post({ url: '/mock/user/login', data })
  // platform=0 表示管理后台,后端据此校验账号是否属于该系统
  return request.post({ url: '/barV2/console/login', data: { ...data, platform: 0 } })
}

// 获取用户信息
export const getUserInfoApi = (): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getUserInfo' })
}

// 获取用户信息
export const getCurUserDetailApi = (): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/console/user/getCurUserDetail' })
}

// 退出登录
export const loginOutApi = (): Promise<IResponse> => {
  // return request.get({ url: '/mock/user/loginOut' })
  return request.post({ url: '/barV2/console/logout' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
